export default "__VITE_ASSET__Biue5wpw__"